/* ============================================================
   RACEFACTORY — Service page
   1) Total binding
   2) Qty +/- controls multibutton
   3) Radio deselezionabili
   4) Swatch service → look pulsanti radio (label + prezzo via mapping)
   ============================================================ */
(function () {
  'use strict';

  var ROOT_ID = 'template-product-service';
  var TARGET_OPTION_COUNT = 4;

  var SVC_SWATCH_OPTIONS = {
    'v_25631831': { label: 'EZO™ Japan',       price: '(+€22.00)'  },
    'v_25631832': { label: 'ZeroFactory Race', price: '(+€72.00)'  },
    'v_25631833': { label: 'CeramicSpeed',     price: '(+€178.00)' },
    'v_25631834': { label: 'EZO™ Japan',       price: '(+€46.00)'  },
    'v_25631835': { label: 'ZeroFactory Race', price: '(+€144.00)' },
    'v_25631836': { label: 'CeramicSpeed',     price: '(+€356.00)' },
    'v_25631837': { label: 'Ruota libera',     price: ''           },
    'v_25631838': { label: 'Ruota anteriore',  price: '(+€20.00)'  },
    'v_25631839': { label: 'Ruota posteriore', price: '(+€20.00)'  }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else { start(); }

  function start() {
    var root = document.getElementById(ROOT_ID);
    if (!root) return;
    var totalCtrl  = createTotalBinding(root);
    var qtyCtrl    = createQtyControls(root);
    var radioCtrl  = createDeselectableRadios(root);
    var swatchCtrl = createSvcSwatchButtons(root);
    totalCtrl.tryInit(); qtyCtrl.scan(); radioCtrl.scan(); swatchCtrl.scan();
    if (typeof MutationObserver === 'undefined') return;
    var obs = new MutationObserver(function () {
      totalCtrl.tryInit(); qtyCtrl.scan(); radioCtrl.scan(); swatchCtrl.scan();
    });
    obs.observe(root, { childList: true, subtree: true });
  }

  function createSvcSwatchButtons(root) {
    var deselectedGroups = {};

    function scan() {
      var swatches = root.querySelectorAll('.mw-option--type-swatch');
      for (var i = 0; i < swatches.length; i++) {
        var option = swatches[i];
        if (option.dataset.rfSvcSwatch === '1') continue;
        option.dataset.rfSvcSwatch = '1';
        decorateOption(option);
      }
    }

    function decorateOption(option) {
      var optionId = option.getAttribute('data-option-id') || option.id || '';
      var values = option.querySelectorAll('.mw-option__value[data-value-id]');
      for (var i = 0; i < values.length; i++) decorateValue(values[i]);
      attachDeselect(option, optionId);
    }

    function decorateValue(valueEl) {
      if (valueEl.querySelector('.rf-svc-radio-btn')) return;
      var valueId = valueEl.getAttribute('data-value-id');
      var data = SVC_SWATCH_OPTIONS[valueId];
      if (!data) return;
      var labelWrap = valueEl.querySelector('label.mw-label');
      if (!labelWrap) return;
      var btn = document.createElement('div');
      btn.className = 'rf-svc-radio-btn';
      var labelSpan = document.createElement('span');
      labelSpan.className = 'rf-svc-radio-label';
      labelSpan.textContent = data.label;
      btn.appendChild(labelSpan);
      if (data.price) {
        var priceSpan = document.createElement('span');
        priceSpan.className = 'rf-svc-radio-price';
        priceSpan.textContent = data.price;
        btn.appendChild(priceSpan);
      }
      labelWrap.appendChild(btn);
    }

    function attachDeselect(option, optionId) {
      option.addEventListener('pointerdown', function (ev) {
        var input = findSwatchRadioInPath(ev.target);
        if (!input) return;
        input.dataset.rfWasChecked = (input.checked || hasSelectedClass(input)) ? '1' : '0';
      }, true);
      option.addEventListener('click', function (ev) {
        var input = findSwatchRadioInPath(ev.target);
        if (!input) return;
        if (input.dataset.rfWasChecked === '1') {
          ev.preventDefault();
          ev.stopImmediatePropagation();
          deselectedGroups[optionId] = input.value || input.id;
          uncheckSwatch(input);
          watchSwatchUncheck(input, optionId);
        } else {
          delete deselectedGroups[optionId];
        }
        input.dataset.rfWasChecked = '0';
      }, true);
      option.addEventListener('change', function (ev) {
        var t = ev.target;
        if (!(t && t.matches && t.matches('input.mw-option__control[type="radio"]'))) return;
        var intent = deselectedGroups[optionId];
        if (intent && (t.value === intent || t.id === intent) && t.checked) {
          ev.stopImmediatePropagation();
          t.checked = false;
          stripSelectedClassSvc(t);
          setTimeout(function () { fire(t, 'change'); }, 0);
        }
      }, true);
    }

    function uncheckSwatch(input) {
      input.checked = false;
      stripSelectedClassSvc(input);
      setTimeout(function () {
        fire(input, 'input');
        fire(input, 'change');
      }, 0);
    }

    function watchSwatchUncheck(input, optionId) {
      var start = Date.now();
      var iv = setInterval(function () {
        if (Date.now() - start > 1500) { clearInterval(iv); return; }
        var intent = deselectedGroups[optionId];
        if (!intent) { clearInterval(iv); return; }
        if ((input.checked || hasSelectedClass(input)) &&
            (input.value === intent || input.id === intent)) {
          input.checked = false;
          stripSelectedClassSvc(input);
        }
      }, 40);
    }

    return { scan: scan };
  }

  function findSwatchRadioInPath(el) {
    var node = el;
    while (node && node !== document) {
      if (node.classList && node.classList.contains('mw-option__value')) {
        return node.querySelector('input.mw-option__control[type="radio"]');
      }
      node = node.parentNode;
    }
    return null;
  }

  function hasSelectedClass(input) {
    var v = input.closest ? input.closest('.mw-option__value') : null;
    return !!(v && v.classList.contains('mw-option__value--selected'));
  }

  function stripSelectedClassSvc(input) {
    var v = input.closest ? input.closest('.mw-option__value') : null;
    if (v) v.classList.remove('mw-option__value--selected');
  }

  function createDeselectableRadios(root) {
    var deselectedGroups = {};
    function scan() {
      var options = root.querySelectorAll('.mw-option--type-radio');
      for (var i = 0; i < options.length; i++) {
        var option = options[i];
        if (option.dataset.rfDeselectable === '1') continue;
        option.dataset.rfDeselectable = '1';
        attachOption(option);
      }
    }
    function attachOption(option) {
      var optionId = option.getAttribute('data-option-id') || option.id || '';
      option.addEventListener('pointerdown', function (ev) {
        var input = findRadioInPath(ev.target);
        if (!input) return;
        input.dataset.rfWasChecked = (input.checked || hasSelectedClass(input)) ? '1' : '0';
      }, true);
      option.addEventListener('click', function (ev) {
        var input = findRadioInPath(ev.target);
        if (!input) return;
        if (input.dataset.rfWasChecked === '1') {
          ev.preventDefault();
          ev.stopImmediatePropagation();
          deselectedGroups[optionId] = input.value || input.id;
          uncheckAndNotify(input);
          watchAndForceUncheck(input, optionId);
        } else {
          delete deselectedGroups[optionId];
        }
        input.dataset.rfWasChecked = '0';
      }, true);
      option.addEventListener('change', function (ev) {
        var t = ev.target;
        if (!(t && t.matches && t.matches('input.mw-option__control[type="radio"]'))) return;
        var intent = deselectedGroups[optionId];
        if (intent && (t.value === intent || t.id === intent) && t.checked) {
          ev.stopImmediatePropagation();
          t.checked = false;
          stripSelectedClass(t);
          setTimeout(function () { fire(t, 'change'); }, 0);
        }
      }, true);
    }
    function uncheckAndNotify(input) {
      input.checked = false;
      stripSelectedClass(input);
      setTimeout(function () { fire(input, 'input'); fire(input, 'change'); }, 0);
    }
    function stripSelectedClass(input) {
      var v = input.closest ? input.closest('.mw-option__value') : null;
      if (v) v.classList.remove('mw-option__value--selected');
    }
    function watchAndForceUncheck(input, optionId) {
      var start = Date.now();
      var iv = setInterval(function () {
        if (Date.now() - start > 1500) { clearInterval(iv); return; }
        var intent = deselectedGroups[optionId];
        if (!intent) { clearInterval(iv); return; }
        if ((input.checked || hasSelectedClass(input)) &&
            (input.value === intent || input.id === intent)) {
          input.checked = false;
          stripSelectedClass(input);
        }
      }, 40);
    }
    return { scan: scan };
  }

  function findRadioInPath(el) {
    var node = el;
    while (node && node !== document) {
      if (node.classList && node.classList.contains('mw-option__value')) {
        return node.querySelector('input.mw-option__control[type="radio"]');
      }
      node = node.parentNode;
    }
    return null;
  }

  function createTotalBinding(root) {
    var inited = false, lastValue = null, sourceEl = null, targetEl = null, observer = null, rafId = null;
    function tryInit() {
      if (inited) { sync(); return; }
      targetEl = root.querySelector('.modal_price .current_price');
      sourceEl = root.querySelector('.mw-apo-price-custom .mw-text--style-strong');
      if (!targetEl) return;
      if (!lastValue) write('€0,00');
      if (!sourceEl) return;
      if (typeof MutationObserver !== 'undefined') {
        observer = new MutationObserver(schedule);
        connect();
      }
      inited = true;
      sync();
    }
    function readSource() {
      if (!sourceEl) return '€0,00';
      var txt = (sourceEl.textContent || '').trim();
      if (!txt) return '€0,00';
      var m = txt.match(/€\s*[\d.,]+/);
      var value = m ? m[0].replace(/\s+/g, '') : txt;
      if (/^€\s*0[,.]?0*$/.test(value)) value = '€0,00';
      return value;
    }
    function write(value) {
      if (!targetEl) return;
      if (value === lastValue) return;
      lastValue = value;
      if (observer) observer.disconnect();
      targetEl.textContent = value;
      if (observer && sourceEl) connect();
    }
    function sync() { rafId = null; if (sourceEl) write(readSource()); }
    function schedule() { if (rafId !== null) return; rafId = window.requestAnimationFrame(sync); }
    function connect() { observer.observe(sourceEl, { childList: true, subtree: true, characterData: true }); }
    return { tryInit: tryInit };
  }

  function createQtyControls(root) {
    function scan() {
      var allOptions = root.querySelectorAll('.mw-option--type-multibutton');
      if (!allOptions.length) return;
      var n = Math.min(TARGET_OPTION_COUNT, allOptions.length);
      for (var i = 0; i < n; i++) {
        var option = allOptions[i];
        if (option.classList.contains('rf-qty-option')) continue;
        option.classList.add('rf-qty-option');
        var values = option.querySelectorAll('.mw-option__value');
        for (var j = 0; j < values.length; j++) decorateValue(values[j]);
      }
    }
    return { scan: scan };
  }

  function decorateValue(valueEl) {
    if (valueEl.querySelector('.rf-qty-row')) return;
    var checkbox = valueEl.querySelector('.mw-option__control[type="checkbox"]');
    var qtyInput = valueEl.querySelector('.mw-option__value-qty-control');
    var labelEl  = valueEl.querySelector('.mw-option__value-text');
    var priceEl  = valueEl.querySelector('.mw-option__price');
    if (!checkbox) return;
    var labelText = labelEl ? labelEl.textContent.trim() : '';
    var priceText = priceEl ? priceEl.textContent.trim() : '';
    var row = document.createElement('div');
    row.className = 'rf-qty-row';
    var labelNode = document.createElement('span');
    labelNode.className = 'rf-qty-label';
    labelNode.textContent = labelText;
    var controls = document.createElement('div');
    controls.className = 'rf-qty-controls';
    var btnMinus = document.createElement('button');
    btnMinus.type = 'button';
    btnMinus.className = 'rf-qty-btn rf-qty-minus';
    btnMinus.textContent = '−';
    btnMinus.setAttribute('aria-label', 'Diminuisci');
    var qtySpan = document.createElement('span');
    qtySpan.className = 'rf-qty-value';
    var btnPlus = document.createElement('button');
    btnPlus.type = 'button';
    btnPlus.className = 'rf-qty-btn rf-qty-plus';
    btnPlus.textContent = '+';
    btnPlus.setAttribute('aria-label', 'Aumenta');
    controls.appendChild(btnMinus);
    controls.appendChild(qtySpan);
    controls.appendChild(btnPlus);
    var priceNode = document.createElement('span');
    priceNode.className = 'rf-qty-price';
    priceNode.textContent = priceText;
    row.appendChild(labelNode);
    row.appendChild(controls);
    row.appendChild(priceNode);
    valueEl.appendChild(row);
    var initialQty = checkbox.checked ? readQty(qtyInput, 1) : 0;
    setState(initialQty);
    btnPlus.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      setState(getQty() + 1);
    });
    btnMinus.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      var q = getQty();
      if (q <= 0) return;
      setState(q - 1);
    });
    function getQty() { return parseInt(qtySpan.textContent, 10) || 0; }
    function setState(qty) {
      if (qty < 0) qty = 0;
      qtySpan.textContent = String(qty);
      if (qty === 0) {
        if (checkbox.checked) { checkbox.checked = false; fire(checkbox, 'change'); fire(checkbox, 'click'); }
        if (qtyInput) { qtyInput.disabled = true; qtyInput.value = '1'; }
        btnMinus.disabled = true;
        valueEl.classList.remove('rf-qty-active');
      } else {
        if (!checkbox.checked) { checkbox.checked = true; fire(checkbox, 'change'); fire(checkbox, 'click'); }
        if (qtyInput) {
          qtyInput.disabled = false;
          if (parseInt(qtyInput.value, 10) !== qty) {
            qtyInput.value = String(qty);
            fire(qtyInput, 'input');
            fire(qtyInput, 'change');
          }
        }
        btnMinus.disabled = false;
        valueEl.classList.add('rf-qty-active');
      }
    }
  }

  function readQty(input, fallback) {
    if (!input) return fallback;
    var n = parseInt(input.value, 10);
    return isNaN(n) || n < 1 ? fallback : n;
  }
  function fire(el, type) {
    var evt;
    try { evt = new Event(type, { bubbles: true }); }
    catch (e) { evt = document.createEvent('Event'); evt.initEvent(type, true, true); }
    el.dispatchEvent(evt);
  }
})();
